import { Draft, createSlice } from '@reduxjs/toolkit';
import { fetchActionPlanExists } from 'reduxStore/actionPlans/asyncActions';
import { Resource } from 'model/Resource';
import { ActionPlanExistsResponse } from 'api/dto/new/ActionPlan/ActionPlanExists.dto';

import { ActionPlansState, STORE_NAME } from './initialState';

export const actionPlansSlice = createSlice({
  name: STORE_NAME,
  initialState: ActionPlansState.INITIAL_DOMAIN,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchActionPlanExists.pending, (state) => {
        state.exists = Resource.createPendingResource(state.exists.data);
      })
      .addCase(fetchActionPlanExists.fulfilled, (state, action) => {
        state.exists = Resource.createResolvedResource({ data: action.payload });
      })
      .addCase(fetchActionPlanExists.rejected, (state, action) => {
        state.exists = Resource.createRejectedResource({
          data: state.exists.data,
          error: action.payload ?? action.error,
        }) as Draft<Resource<ActionPlanExistsResponse | null>>;
      });
  },
});
